export const setGiftAmount = ({giftAmount}) => ({
  type: 'SET_GIFT_AMOUNT',
  giftAmount,
});

export const setGiftRecipient = ({recipientEmail}) => ({
  type: 'SET_GIFT_RECIPIENT',
  recipientEmail,
});


export const setGiftSender = ({senderEmail}) => ({
  type: 'SET_GIFT_SENDER',
  senderEmail,
});

export const setTemplate = ({template}) => ({
  type: 'SET_TEMPLATE',
  template,
});

export const setNote = ({note}) => ({
  type: 'SET_NOTE',
  note,
});

export const receiveWallet = (wallet) => ({
    type: 'RECEIVE_WALLET',
    wallet,
    receivedAt: Date.now(),
});

export const fundingInitiated = () => ({
  type: 'FUNDING_INITIATED',
  receivedAt: Date.now(),
});

export const setConversionRates = (conversionRates) => ({
  type: 'SET_CONVERSION_RATES',
  conversionRates,
  receivedAt: Date.now(),
});



// WEBPACK FOOTER //
// ./src/Actions/index.js